// extracted by mini-css-extract-plugin
export default {"footerContainer":"ExchangeFooter_footerContainer__y+f1R"};